const TEAM_DETAILS_EVENTS = {
  TEAMS_PAGE_SHOWN: {
    name: "TEAMS_PAGE_SHOWN",
    category: "TEAM_DETAILS"
  },
  TEAM_REQUEST_REJECTION_MODAL_SHOW: {
    name: "TEAM_REQUEST_REJECTION_MODAL_SHOW",
    category: "TEAM_DETAILS"
  },

  // add credits
  ADD_CREDITS_CLICKED: {
    name: "ADD_CREDITS_CLICKED",
    category: "TEAM_DETAILS"
  },
  ADD_CREDITS_POPUP_DISMISSED: {
    name: "ADD_CREDITS_POPUP_DISMISSED",
    category: "TEAM_DETAILS"
  },
  ADD_CREDITS_POPUP_CONFIRM_CLICKED: {
    name: "ADD_CREDITS_POPUP_CONFIRM_CLICKED",
    category: "TEAM_DETAILS"
  },
  ADD_CREDITS_POPUP_SUCCESS: {
    name: "ADD_CREDITS_POPUP_SUCCESS",
    category: "TEAM_DETAILS"
  },

  // remove credits
  REMOVE_CREDITS_CLICKED: {
    name: "REMOVE_CREDITS_CLICKED",
    category: "TEAM_DETAILS"
  },
  REMOVE_CREDITS_POPUP_DISMISSED: {
    name: "REMOVE_CREDITS_POPUP_DISMISSED",
    category: "TEAM_DETAILS"
  },
  REMOVE_CREDITS_POPUP_CONFIRM_CLICKED: {
    name: "REMOVE_CREDITS_POPUP_CONFIRM_CLICKED",
    category: "TEAM_DETAILS"
  },
  REMOVE_CREDITS_POPUP_SUCCESS: {
    name: "REMOVE_CREDITS_POPUP_SUCCESS",
    category: "TEAM_DETAILS"
  },

  // remove user
  REMOVE_MEMBER_CLICKED: {
    name: "REMOVE_MEMBER_CLICKED",
    category: "TEAM_DETAILS"
  },
  REMOVE_MEMBER_POPUP_DISMISSED: {
    name: "REMOVE_MEMBER_POPUP_DISMISSED",
    category: "TEAM_DETAILS"
  },
  REMOVE_MEMBER_POPUP_CONFIRM_CLICKED: {
    name: "REMOVE_MEMBER_POPUP_CONFIRM_CLICKED",
    category: "TEAM_DETAILS"
  },
  REMOVE_MEMBER_POPUP_SUCCESS: {
    name: "REMOVE_MEMBER_POPUP_SUCCESS",
    category: "TEAM_DETAILS"
  },

  // add member
  ADD_MEMBER_CLICKED: {
    name: "ADD_MEMBER_CLICKED",
    category: "TEAM_DETAILS"
  },
  ADD_MEMBER_POPUP_DISMISSED: {
    name: "ADD_MEMBER_POPUP_DISMISSED",
    category: "TEAM_DETAILS"
  },
  ADD_MEMBER_POPUP_CONFIRM_CLICKED: {
    name: "ADD_MEMBER_POPUP_CONFIRM_CLICKED",
    category: "TEAM_DETAILS"
  },
  ADD_MEMBER_POPUP_SUCCESS: {
    name: "ADD_MEMBER_POPUP_SUCCESS",
    category: "TEAM_DETAILS"
  },

  // resend invite
  RESEND_INVITE_CLICKED: {
    name: "RESEND_INVITE_CLICKED",
    category: "TEAM_DETAILS"
  },

  RESEND_INVITE_SUCCESS: {
    name: "RESEND_INVITE_SUCCESS",
    category: "TEAM_DETAILS"
  },

  CREDIT_BALANCE_CLICKED: {
    name: "CREDIT_BALANCE_CLICKED",
    category: "TEAM_DETAILS"
  },

  SUB_USER_QUICK_ACTIONS_CLICKED: {
    name: "SUB_USER_QUICK_ACTIONS_CLICKED",
    category: "TEAM_DETAILS"
  },

  // Incoming Event
  IR_ACCEPT_CLICKED: {
    name: "IR_ACCEPT_CLICKED",
    category: "TEAM_DETAILS"
  },
  IR_DECLINE_CLICKED: {
    name: "IR_DECLINE_CLICKED",
    category: "TEAM_DETAILS"
  }
};

export default TEAM_DETAILS_EVENTS;
